<template>
  <div class="login">
    <div class="loginBox">
      <div class="loginLeft fl">
        <img src="~@/assets/images/logo.png" class="log" />

        <div class="loginLeft_text">
          <div>PC REPORT OF BUSINESS</div>

          <div>电脑端报表</div>
        </div>
      </div>
      <div class="loginRight fl">
        <div class="loginRight_title">欢迎登录</div>
        <a-form-model class="user-layout-login" ref="formLogin" :model="form" :rules="rules" @submit="handleSubmit">
          <a-form-model-item class="form_item" prop="loginName" ref="loginName" v-if="form.loginType === '1'">
            <a-input size="large" type="text" v-model="form.loginName" placeholder="请输入账号" :maxLength="11">
              <!-- <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />-->
            </a-input>
          </a-form-model-item>

          <a-form-model-item class="form_item" prop="password" ref="password" v-if="form.loginType === '1'">
            <a-input-password size="large" v-model="form.password" placeholder="请输入密码">
              <!--<a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />-->
            </a-input-password>
          </a-form-model-item>

          <a-form-model-item class="form_item" prop="loginName" ref="loginName" v-if="form.loginType === '2'">
            <a-input size="large" type="text" v-model="form.mobile" placeholder="请输入账号" :maxLength="11">
              <!--<a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />-->
            </a-input>
          </a-form-model-item>

          <a-form-model-item class="form_item" prop="password" ref="password" v-if="form.loginType === '2'">
            <div class="flex nowrap justify-between code">
              <a-input size="large" v-model="form.verificationCode" placeholder="请输入验证码">
                <!-- <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />-->
              </a-input>

              <a-button class="code_btn" size="large" @click="onCodeClick" :disabled="msgStatus">
                {{ msg }}
              </a-button>
            </div>
          </a-form-model-item>

          <a-form-model-item class="form_item">
            <a-button size="large" type="primary" htmlType="submit" class="loginBtn">确定</a-button>
          </a-form-model-item>

          <a-form-model-item class="form_item">
            <div class="flex justify-between">
              <div
                class="white-border"
                :class="[form.loginType === '1' ? 'white-border--active' : 'white-border']"
                @click="handleTabClick('1')"
              >
                密码登录
              </div>

              <div
                class="white-border"
                :class="[form.loginType === '2' ? 'white-border--active' : 'white-border']"
                @click="handleTabClick('2')"
              >
                验证码登录
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <a-modal :centered="true" title="选择所属商户" :visible="visible" @cancel="handleCancel">
      <a-list item-layout="horizontal" :data-source="tenantList">
        <a-list-item slot="renderItem" slot-scope="item" @click="handleOk(item.tenantId)">
          <a-list-item-meta description="">
            <a slot="title" href="javascript:;">{{ item.tenantName }}</a>
          </a-list-item-meta>
        </a-list-item>
      </a-list>

      <template slot="footer">
        <div class="mpm_modal_buttons"></div>
      </template>
    </a-modal>
    <!-- 全屏等待loding -->
    <div class="page-loding flex center" v-if="loding">
      <a-spin size="large" tip="登录中..."></a-spin>
    </div>
    <!-- 全屏等待loding -->
    <div class="page-loding flex center" v-if="loding">
      <a-spin size="large" tip="登录中..."></a-spin>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js'
  // import debounce from 'lodash/debounce'
  import { interfaceOfLogin, interfaceOfOperationAesKeys, interfaceOfSms } from 'apis/common'
  import { validatePhone } from 'utils/validator'
  let FLAG_OK = true
  export default {
    data() {
      return {
        isOpen: false, // 默认展开商户列表
        customActiveKey: 'tab1',
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        isLoginError: false,
        requiredTwoStepCaptcha: false,
        stepCaptchaVisible: false,
        form: {
          loginName: '',
          password: '',
          loginType: '1', // '1'是代表 密码登录  '2' 是验证码登录
        },
        rules: {
          loginName: [
            { required: true, message: '请输入帐户名', trigger: 'blur' },
            { validator: this.handleUsernameOrEmail },
          ],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        state: {
          time: 60,
          loginBtn: false,
          // login type: 0 email, 1 username, 2 telephone
          loginType: 1,
          smsSendBtn: false,
        },
        aesKey: '',
        inputLength: 11,
        msg: '获取验证码',
        msgStatus: false,
        newCode: '',
        visible: false,
        hasChooseTenantId: '', // 已選的商戶
        tenantList: [], // 商戶列表
        size: 'large',
        loding: false,
      }
    },
    created() {
      window.sessionStorage.setItem('loginName', '')
      this.getAesKeys()
    },

    methods: {
      // 切换 密码登录 或 验证码登录
      handleTabClick(type) {
        this.$refs.formLogin.resetFields()
        this.isShow = false
        this.state.loginBtn = false
        this.form.loginType = type
        if (this.form.loginType === '1') {
          this.form = {
            loginName: '',
            password: '',
            loginType: '1', // '1'是代表 密码登录  '2' 是验证码登录
          }
          this.rules = null
          this.rules = {
            loginName: [
              { required: true, message: '请输入帐户名', trigger: 'blur' },
              { validator: this.handleUsernameOrEmail },
            ],
            password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          }
        } else {
          this.form = {
            mobile: '',
            loginType: '2', // '1'是代表 密码登录  '2' 是验证码登录
            verificationCode: '',
          }
          this.rules = null
          this.rules = {
            mobile: [
              { required: true, message: '请输入手机号', trigger: 'blur' },
              { validator: this.handleUsernameOrEmail },
            ],
            verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
          }
        }
        console.log(66, this.form, this.rules)
      },
      // 点击获取验证码
      onCodeClick() {
        // 调接口去获取验证码   获取到之后开始 60s倒计时
        if (!FLAG_OK) {
          return
        }
        if (!validatePhone(this.form.mobile)) return
        this.$refs.formLogin.validate((valid, object) => {
          if (valid) {
            interfaceOfSms({ data: { mobile: this.form.mobile, type: 1 } }).then((res) => {
              this.msgStatus = true
              let num = 60
              this.$message.success('验证码已成功发送，请注意查收！', 10)
              let timer = setInterval(() => {
                FLAG_OK = false
                num--
                this.msg = `${num}秒发送`
                if (!num) {
                  this.msgStatus = false
                  FLAG_OK = true
                  this.msg = '重新发送'
                  clearInterval(timer)
                }
              }, 1000)
            })
          }
        })
      },
      // 点击登录
      handleSubmit(e) {
        this.loding = true
        // 清除掉上次所选的 商户
        this.hasChooseTenantId = ''
        window.sessionStorage.removeItem('tenantId', '')
        if (this.form.loginType == '1') {
          // 账户名 密码登录
          e.preventDefault()
          delete this.form.mobile
          delete this.form.verificationCode
          this.$refs.formLogin.validate((valid, object) => {
            if (valid) {
              this.state.loginBtn = true
              let params = this.$utils.deepCopy(this.form)
              params.loginPwd = CryptoJS.AES.encrypt(this.form.password, CryptoJS.enc.Utf8.parse(this.aesKey), {
                padding: CryptoJS.pad.Pkcs7,
                iv: CryptoJS.enc.Utf8.parse(this.aesKey),
                mode: CryptoJS.mode.CBC,
              }).toString()
              console.log('传递前', params)
              this.loginFirst(params)
            } else {
              this.state.loginBtn = false
            }
          })
        } else {
          // 手机号 验证码登录
          e.preventDefault()
          delete this.form.loginName
          delete this.form.password
          this.$refs.formLogin.validate((valid, object) => {
            if (valid) {
              if (!this.form.mobile) {
                this.$message.warning('请输入手机号', 10)
                return false
              }
              if (!this.form.verificationCode) {
                this.$message.warning('请输入验证码', 10)
                return false
              }
              this.state.loginBtn = true
              console.log('form1', this.form)
              let params = this.$utils.deepCopy(this.form)
              params.mobile = this.form.mobile
              this.loginFirst(params)
            } else {
              this.state.loginBtn = false
            }
          })
        }
        setTimeout(() => {
          this.loding = false
        }, 1000)
      },
      loginFirst(params) {
        interfaceOfLogin({ data: params })
          .then((res) => {
            this.tenantList = res.employees
            if (this.tenantList.length > 0) {
              this.visible = true
              this.isOpen = true
            } else {
              window.sessionStorage.setItem('token', res.token)
              window.sessionStorage.setItem('userInfo', JSON.stringify(res.loginUserVO))
              this.visible = false
              this.loginSuccess()
            }
          })
          .finally(() => {
            this.state.loginBtn = true
          })
      },
      /**
       * 获取密钥
       */
      getAesKeys() {
        interfaceOfOperationAesKeys().then((res) => {
          this.aesKey = res
        })
      },
      /**
       * 对账户名进行校验
       */
      handleUsernameOrEmail(rule, value, callback) {
        const { state } = this
        const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
        if (regex.test(value)) {
          state.loginType = 0
        } else {
          state.loginType = 1
        }
        callback()
      },
      // 选择商户
      handleOk(tenantId) {
        this.hasChooseTenantId = tenantId
        console.log('确定', tenantId)
        if (!this.hasChooseTenantId) {
          this.$message.warning('请选择商户！', 10)
          return false
        } else {
          window.sessionStorage.setItem('tenantId', this.hasChooseTenantId)
        }
        if (this.form.loginType === '1') {
          delete this.form.mobile
          delete this.form.verificationCode
          this.$refs.formLogin.validate((valid, object) => {
            if (valid) {
              this.state.loginBtn = true
              let params = this.$utils.deepCopy(this.form)
              params.loginPwd = CryptoJS.AES.encrypt(this.form.password, CryptoJS.enc.Utf8.parse(this.aesKey), {
                padding: CryptoJS.pad.Pkcs7,
                iv: CryptoJS.enc.Utf8.parse(this.aesKey),
                mode: CryptoJS.mode.CBC,
              }).toString()
              params.tenantId = this.hasChooseTenantId
              this.loginSecond(params)
            }
          })
        } else {
          delete this.form.loginName
          delete this.form.password
          this.$refs.formLogin.validate((valid, object) => {
            if (valid) {
              this.state.loginBtn = true
              console.log('form1', this.form)
              let params = this.$utils.deepCopy(this.form)
              params.tenantId = this.hasChooseTenantId
              this.loginSecond(params)
            }
          })
        }
      },
      // 点击 选择商户之后调的接口
      loginSecond(params) {
        interfaceOfLogin({ data: params })
          .then((res) => {
            window.sessionStorage.setItem('token', res.token)
            window.sessionStorage.setItem('userInfo', JSON.stringify(res.loginUserVO))
            this.visible = false
            this.loginSuccess()
          })
          .finally(() => {
            this.state.loginBtn = true
          })
      },
      // 登录成功
      loginSuccess() {
        this.$router.replace({ path: '/' })
        this.isLoginError = false
        window.localStorage.removeItem('createdEmployee')
      },
      handleCancel(e) {
        console.log('Clicked cancel button')
        this.visible = false
      },
    },
  }
</script>

<style scoped>
  .page-loding {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }

  .fl {
    float: left;
  }

  .form_item {
    width: 260px;
    margin: 25px auto;
  }

  .login {
    width: 100%;
    height: 100vh;
    overflow: auto;
    background: url('~@/assets/images/loginBg.png') no-repeat center;
    background-size: 100% 100%;
  }

  .loginBox {
    width: 1246px;
    height: 648px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -300px 0 0 -623px;
  }

  .loginLeft {
    position: relative;
    width: 836px;
    height: 600px;
    background: url('~@/assets/images/login.png') no-repeat center;
    background-size: 100% 100%;
  }

  .loginRight {
    width: 410px;
    height: 600px;
    background: #ffffff;
  }

  .log {
    width: 180px;
    margin: 50px;
    display: block;
  }

  .loginLeft_text {
    position: absolute;
    bottom: 80px;
    right: 120px;
    text-align: right;
    color: #ffffff;
  }

  .loginLeft_text > div:first-child {
    font-size: 30px;
    font-weight: bold;
    line-height: 1;
  }

  .loginLeft_text > div:last-child {
    margin-top: 15px;
    font-size: 20px;
    line-height: 1;
  }

  .loginRight_title {
    width: 104px;
    color: #333333;
    font-size: 26px;
    font-weight: 500;
    margin: 204px auto 0;
    white-space: nowrap;
    border-bottom: #7468f2 4px solid;
  }

  .loginInput {
    width: 266px;
  }

  .loginBtn {
    width: 266px;
    background-color: #7468f2;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 34px;
    border-radius: 4px;
    cursor: pointer;
  }

  .white-border {
    border-bottom: 2px solid #ffffff;
    cursor: pointer;
  }

  .white-border--active {
    border-bottom: 2px solid #7468f2;
    cursor: pointer;
  }

  .code .ant-input-affix-wrapper {
    width: 70%;
  }

  .code_btn {
    margin-left: 10px;
  }
</style>

<style>
  .ant-modal-body {
    /* padding: 0 24px !important; */
  }
</style>
